import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import PortraitOutlinedIcon from '@mui/icons-material/PortraitOutlined';
import ChatIcon from '@mui/icons-material/Chat';
import TransgenderIcon from '@mui/icons-material/Transgender';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { FormField } from '../../interfaces/User.interface';
import { PhoneInputMask } from '../../utils/FormatedInputMask';
import { Role } from '../../interfaces/constants';

export function studentInfoFields(): FormField[] {
    return [
        {
            name: "firstName",
            question: "First Name*",
            validation: "text",
            required: true,
            questionType: "text",
            icon: <PortraitOutlinedIcon />
        },
        {
            name: "lastName",
            question: "Last Name*",
            validation: "text",
            required: true,
            questionType: "text",
            icon: <PortraitOutlinedIcon />
        },
        {
            name: "gender",
            question: "Gender",
            validation: "text",
            required: false,
            questionType: "autocomplete",
            data: ['Male', 'Female', 'Other'],
            onRender: (item: any) => item,
            props: { variant: "standard" },
            icon: <TransgenderIcon />
        },
        {
            name: "email",
            question: "Email*",
            validation: "email",
            required: false,
            questionType: "text",
            icon: <MailOutlinedIcon />
        },
        {
            name: "phone",
            question: "Phone Number",
            validation: "phone",
            required: false,
            questionType: "text",
            inputProps: {
                inputComponent: PhoneInputMask
            },
            icon: <LocalPhoneIcon />
        },
        {
            name: "wechatId",
            question: "Wechat ID",
            validation: "text",
            required: true,
            questionType: "text",
            icon: <ChatIcon />
        },
        {
            name: "role",
            question: "Role",
            validation: "text",
            required: true,
            questionType: "autocomplete",
            data: [Role.Student, Role.Teacher],
            onRender: (item: any) => item,
            props: { variant: "standard" },
            icon: <TransgenderIcon />
        },
    ];
}

export function addressInfoFields(): FormField[] {
    return [
        {
            name: "address",
            question: "Street",
            validation: "text",
            required: false,
            questionType: "text",
            icon: <HomeOutlinedIcon />
        },
        {
            name: "city",
            question: "City",
            validation: "text",
            required: false,
            questionType: "text",
            icon: <HomeOutlinedIcon />
        },
        {
            name: "province",
            question: "Province",
            validation: "text",
            required: false,
            questionType: "text",
            icon: <HomeOutlinedIcon />
        },
        {
            name: "postalCode",
            question: "Postal Code",
            validation: "postal",
            required: false,
            questionType: "text",
            icon: <HomeOutlinedIcon />
        },
    ];
}

export function permanentReminderField(): FormField {
    return {
        name: "note",
        question: "Note",
        validation: "text",
        required: false,
        questionType: "text",
        props: { multiline: true, rows: 4, InputLabelProps: { shrink: true }, variant: "outlined" },
    };
}

//course field
export function weeklyCourseFields(): FormField[] {
    return [
      {
        name: "weeklyCourses",
        question: "Weekly Courses",
        validation: "course",
        required: false,
        questionType: "course",
        children: [
          {
            name: "courseName",
            question: "Course Name",
            questionType: "text",
            required: true,
            validation: "text",
          },
          {
            name: "hasDiscount",
            question: "Has Discount",
            questionType: "checkbox",
            required: false,
          },
          {
            name: "price",
            question: "Price",
            questionType: "number",
            required: true,
            validation: "number",
          },
          {
            name: "discountType",
            question: "Discount Type",
            questionType: "text",
            required: false,
          },
          {
            name: "discountValue",
            question: "Discount Value",
            questionType: "number",
            required: false,
            validation: "number",
          },
        ],
      },
    ];
  }
  